/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryDto } from '../../models/gallery-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface GalleryControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo?: number;

/**
 * 갤러리 유형 필터
 */
  type?: 'PHOTO' | 'VIDEO';

/**
 * 출처 필터
 */
  sourceType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';

/**
 * 갤러리 카테고리 필터
 */
  category?: 'PROMOTION' | 'GENERAL' | 'HOME';

/**
 * 노출 여부
 */
  isExposed?: boolean;
}

export function galleryControllerSearchV1(http: HttpClient, rootUrl: string, params?: GalleryControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<GalleryDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, galleryControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('type', params.type, {});
    rb.query('sourceType', params.sourceType, {});
    rb.query('category', params.category, {});
    rb.query('isExposed', params.isExposed, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<GalleryDto>;
      }>;
    })
  );
}

galleryControllerSearchV1.PATH = '/api/v1/gallery/search';
